import { createSelector } from "reselect";
import get from "lodash/get";
import { genericSelector } from "ducks/selectors";
import _ from "lodash";

const cisFormDomain = state => get(state, "form.CisRequestForm.values", {});

/*
 ************** CIS Form Selectors ************
 */
export const cisSelector = createSelector(cisFormDomain, cisForm => cisForm);

/*
 ************** Make Selectors ************
 */

export const makeSelectCisForm = () => cisSelector;

export const makeSelectCisFormInitialValues = () =>
  createSelector(genericSelector, generic => {
    return {
      country_code: get(generic, "contact_number.prefix")
    };
  });

export const makeSelectCisFormParams = () =>
  createSelector(cisSelector, cisForm => {
    let domain = get(cisForm, "email_domain");
    const otherDomains = get(cisForm, "email_domains", []);

    if (otherDomains.length) {
      domain +=
        "," +
        _.reduce(otherDomains, function(sum, n) {
          if (n !== undefined) {
            return sum + "," + n;
          }
        });
    }

    return {
      external: {
        company_name: get(cisForm, "company_name"),
        contact_number: get(cisForm, "contact_number"),
        domains: domain || "",
        email: get(cisForm, "email"),
        name: get(cisForm, "full_name"),
        query: get(cisForm, "more_details") || "",
        size: get(cisForm, "company_size")
      }
    };
  });
